export interface ListResponseModel<T> {
	pageIndex: number;
	count: number;
	totalPages: number;
	items: T;
  categories: T;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
}

export const toQueryString = <T extends object>(params: T): string => {
    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (value instanceof Date) {
          const pad = (n: number) => String(n).padStart(2, '0');
          const localDate = `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
          return `${encodeURIComponent(key)}=${encodeURIComponent(localDate)}`;
        }
        const serialized = typeof value === 'string' ? value.trim() : String(value);
        return `${encodeURIComponent(key)}=${encodeURIComponent(serialized)}`;
      })
      .join('&');

    return queryString ? `?${queryString}` : '';
  };

export const toQueryStringWithArray = <T extends object>(params: T): string => {
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(typeof v === 'string' ? v.trim() : v)}`);
      }
      if (value instanceof Date) {
        const pad = (n: number) => String(n).padStart(2, '0');
        const localDate = `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
        return `${encodeURIComponent(key)}=${encodeURIComponent(localDate)}`;
      }
      const serialized = typeof value === 'string' ? value.trim() : String(value);
      return `${encodeURIComponent(key)}=${encodeURIComponent(serialized)}`;
    })
    .join('&');

  return queryString ? `?${queryString}` : '';
};